import React, { useState } from 'react';
import {
  Popover,
  Typography,
  Box,
  Stack,
  IconButton,
  Divider,
  Tooltip
} from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { useTheme } from '@material-ui/core/styles';

export default function ProductsPopover({ 
  productNames, 
  open, 
  anchorEl, 
  onClose, 
  eventColor = '#1ccaff' 
}) {
  const theme = useTheme();

  // Split product names by comma and trim whitespace
  const products = productNames ? productNames.split(',').map(p => p.trim()).filter(p => p) : [];

  if (!products.length) return null;

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: theme.shadows[8],
          border: `1px solid ${eventColor}40`,
          backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.background.paper,
        }
      }}
    >
      <Box sx={{ p: 1.5, minWidth: 200, maxWidth: 300 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
          <Typography 
            variant="subtitle2" 
            fontWeight="bold" 
            sx={{ 
              color: eventColor,
              fontSize: '0.9rem'
            }}
          >
            {products.length === 1 ? 'Product' : 'Products'}
          </Typography>
          <IconButton size="small" onClick={onClose} sx={{ p: 0.5 }}>
            <Close sx={{ width: 16, height: 16, color: eventColor }} />
          </IconButton>
        </Stack>
        
        <Divider sx={{ mb: 1.5, borderColor: `${eventColor}40` }} />
        
        <Stack spacing={1}>
          {products.map((product, index) => (
            <Tooltip key={index} title={product} arrow>
              <Box
                sx={{
                  backgroundColor: `${eventColor}15`,
                  border: `1px solid ${eventColor}30`,
                  borderRadius: '6px',
                  padding: '4px 6px',
                  cursor: 'help',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: `${eventColor}25`,
                    border: `1px solid ${eventColor}50`,
                    transform: 'translateY(-1px)'
                  }
                }}
              >
                <Typography
                  color={eventColor}
                  fontSize="0.7rem"
                  sx={{
                    lineHeight: 1.3,
                    opacity: 0.9,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    display: 'block',
                    fontWeight: 500
                  }}
                  variant="body2"
                >
                  • {product}
                </Typography>
              </Box>
            </Tooltip>
          ))}
        </Stack>
      </Box>
    </Popover>
  );
}
